export function forEach(array, callback, scope) {
  for (var i = 0; i < array.length; i++) {
    callback.call(scope, i, array[i]);
  }
};

export function nodeListToArray(nodeList) {
  let tempArray = [];
  forEach(nodeList, (i, elem) => { tempArray.push(elem) });
  return tempArray;
}